import { loadGoogleMaps } from "../../MapsLoader";

let ourMapsContainers = document.querySelectorAll(".our-location");

if (ourMapsContainers.length) {
  loadGoogleMaps().then(() => {
    ourMapsContainers.forEach((container) => {
      let mapContainer = container.querySelector(".map-container");

      let lat = parseFloat(mapContainer.getAttribute("data-lat"));
      let lng = parseFloat(mapContainer.getAttribute("data-lng"));

      let location = {
        lat: lat,
        lng: lng,
      };

      let map = new google.maps.Map(mapContainer, {
        center: location,
        zoom: 11,
        disableDefaultUI: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      });

      new google.maps.Marker({
        position: location,
        map: map,
      });
    });
  });
}
